var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question-divider"},[_c('div',{staticClass:"question-divider__line"}),(_vm.title)?_c('span',{staticClass:"question-divider__title u-typography-helvetica u-text u-text--xs"},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")]):_vm._e(),_c('div',{staticClass:"question-divider__line"})])
}
var staticRenderFns = []

export { render, staticRenderFns }